import { render, staticRenderFns } from "./vgmServiceGuideDialog.vue?vue&type=template&id=72c1bb4d&scoped=true&"
import script from "./vgmServiceGuideDialog.vue?vue&type=script&lang=js&"
export * from "./vgmServiceGuideDialog.vue?vue&type=script&lang=js&"
import style0 from "./vgmServiceGuideDialog.vue?vue&type=style&index=0&id=72c1bb4d&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../../../../../Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72c1bb4d",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('72c1bb4d')) {
      api.createRecord('72c1bb4d', component.options)
    } else {
      api.reload('72c1bb4d', component.options)
    }
    module.hot.accept("./vgmServiceGuideDialog.vue?vue&type=template&id=72c1bb4d&scoped=true&", function () {
      api.rerender('72c1bb4d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/cargo/v0/SeaExport/components/booking/vgm/vgmServiceGuideDialog.vue"
export default component.exports